<div class="page-content-wrapper">
  <app-sidebar-layout #sidebarRef [showMenuToggle]="false">
    <app-worker-exposures class="w-100" [workerExposures]="workerExposures"
      [parameter]="parameter"></app-worker-exposures>
    <section class="card-style-sec exposures-segs-sec info-popups">
      <div class="container-fluid">
        <div class="row segs-particle-risk-row">
          <div class="col-md-12 col-lg-6 border-right border-top">
            <app-exposures-by-segs [exposureBySEGs]="exposureBySEGs" [loading]="loadingExposureBySEGs" [segSort]="segSort"
              [segOrder]="segOrder" (sortSEGEmit)="sortSEG($event)" (showSEGDetailEmit)="showSEGDetailFn($event)"
              (showAllPopupEmit)="showAllPopupFn()"></app-exposures-by-segs>
          </div>
  
          <div class="col-md-12 col-lg-6 border-right border-top">
            <app-exposure-contribution-by-task-group [loading]="loadingTaskGroup"
              [exposureByTaskGroup]="exposureByTaskGroup"
              (toggleTaskGroupPopupEmit)="toggleTaskGroupPopupFn($event)"></app-exposure-contribution-by-task-group>
          </div>
          <!-- <div class="col-md-12 col-lg-4 border-right border-top">
                  <app-exposure-risk-by-withing-seg></app-exposure-risk-by-withing-seg>
                </div> -->
        </div>
        <div class="row location-or-plan-row">
          <div class="col-md-12 col-lg-4 border-right border-top">
            <app-exposure-by-location-group [loading]="loadingLocationGroup"
              [exposureByLocationGroup]="exposureByLocationGroup"></app-exposure-by-location-group>
          </div>
          <div class="col-md-12 col-lg-8 border-top">
            <app-exposure-reduction-plan-status></app-exposure-reduction-plan-status>
          </div>
        </div>
        <div class="row exposure-reduction-plan-row">
          <div class="col-md-12 col-lg-4 border-right border-top">
          </div>
          <div class="col-md-12 col-lg-8 border-top">
            <app-exposure-reduction-plan-items></app-exposure-reduction-plan-items>
          </div>
        </div>
  
      </div>
    </section>
  </app-sidebar-layout>

</div><!--======page-content-wrapper end======-->

<app-exposure-by-segs-popup [showAllPopup]="showAllSEGsPopup" [loading]="loadingExposureBySEGs"
  [segAllOrder]="segAllOrder" [segAllSort]="segAllSort" [exposureBySEGsAll]="exposureBySEGsAll"
  (sortAllSEGEmit)="sortSEG($event)" (showSEGDetailEmit)="showSEGDetailFn($event)"
  (hideAllPopupEmit)="hideAllSEGsPopupFn($event)"></app-exposure-by-segs-popup>

<app-seg-details [show]="showSEGDetail" [selectedSEG]="selectedSEG" [exposureDetail]="exposureDetail"
  [exposureContribution]="exposureContribution"
  [taskRequestType]="taskRequestType" [loading]="loadingExposureContribution"
  [loadingExposureDetail]="loadingExposureDetail" (toggleTaskRequestEmit)="toggleTaskRequest()"
  (hideSEGDetailEmit)="hideSEGDetailFn($event)" (exposureContributionEmit)="updateExposureContribution($event)"
  (toggleTaskwithSEGPopupEmit)="toggleTaskwithSEGPopup($event)"></app-seg-details>

<app-exposure-by-task-group [show]="showTaskGroup" [selectedTaskGroup]="selectedTaskGroup"
  [exposureAllSEGs]="exposureAllSEGs" [loadingAllSEGs]="loadingAllSEGs"
  [loadingExposureByTaskGroup]="loadingExposureByTaskGroup"
  [loadingExposureTaskDistribution]="loadingExposureTaskDistribution"
  [exposureByTaskGroupName]="exposureByTaskGroupName" [exposureTaskDistributionsNew]="exposureTaskDistributionsNew"
  (hideTaskGroupEmit)="hideTaskGroupFn($event)" (toggleTaskPopupEmit)="toggleTaskPopup($event)"></app-exposure-by-task-group>

<app-exposure-by-task [show]="showTaskSupervisor" [selectedSEG]="selectedSEG" [selectedTask]="selectedTask"
  [exposureAllSEGs]="exposureAllSEGs" [loadingAllSEGs]="loadingAllSEGs"
  [loadingExposureTaskSamples]="loadingExposureTaskSamples"
  [loadingExposureTaskDistribution]="loadingExposureTaskDistribution"
  [exposureTaskDistributions]="exposureTaskDistributions" [exposureTaskSamples]="exposureTaskSamples"
  (hideTaskSupervisorEmit)="hideTaskSupervisorFn($event)"
  (redirectToSampleEmit)="redirectToSample($event)"></app-exposure-by-task>
